module.exports = __webpack_public_path__ + "static/media/giftsSent_250_500.90c73c55.png";